// 去除富文本标签
// export function removeHTMLTag(str: any) {
//   str = str.replace(/<\/?[^>]*>/g,''); //去除HTML tag
//   str = str.replace(/[ | ]*\n/g,'\n'); //去除行尾空白
//   //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
//   str=str.replace(/ /ig,'');//去掉
//   return str;
// }
export function removeHTMLTag(str: any) {
  str = str
    .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
    .replace(/<br\/?>/gi, "\n")
    .replace(/<[^>/]+>/g, "")
    .replace(/(\n)?<\/([^>]+)>/g, "")
    .replace(/\u00a0/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/<\/?(img)[^>]*>/gi, "")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/<\/?.+?>/g, "");
  //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
  return str;
}
//设置本地缓存
export const setStorage = function(key: string, obj: object | string) {
  if (typeof obj === "string") {
    localStorage.setItem(key, obj);
  } else {
    localStorage.setItem(key, JSON.stringify(obj));
  }
};

//获取本地缓存
export const getStorage = function(key: string) {
  const val = localStorage.getItem(key);
  if (val) {
    try {
      return JSON.parse(val);
    } catch (e) {
      return val;
    }
  } else {
    return "";
  }
};

//清除本地缓存 如果不传值，清除所有缓存
export const clearStorage = function(key: string) {
  if (key) {
    localStorage.removeItem(key);
  } else {
    localStorage.clear();
  }
};

//时间格式转换yy-mm-dd
export const getFormatDate = function(date: any) {
  const format_date = date.replace(/-/g, "/");
  const time = new Date(format_date);
  const y = time.getFullYear();
  let m: any = time.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d: any = time.getDate();
  d = d < 10 ? "0" + d : d;
  return `${y}/${m}/${d}`;
};

//时间格式转换yy-mm-dd hh:mm:ss
export const getFormatDateTime = function(date: any) {
  const format_date = date.replace(/-/g, "/");
  const time = new Date(format_date);
  const y = time.getFullYear();
  let m: any = time.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d: any = time.getDate();
  d = d < 10 ? "0" + d : d;
  let h: any = time.getHours();
  h = h < 10 ? "0" + h : h;
  let mm: any = time.getMinutes();
  mm = mm < 10 ? "0" + mm : mm;
  let s: any = time.getSeconds();
  s = s < 10 ? "0" + s : s;
  return `${y}/${m}/${d} ${h}:${mm}:${s}`;
};
export const getFormatDateTime2 = function(date: any) {
  const format_date = date.replace(/-/g, "/");
  const time = new Date(format_date);
  const y = time.getFullYear();
  let m: any = time.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d: any = time.getDate();
  d = d < 10 ? "0" + d : d;
  let h: any = time.getHours();
  h = h < 10 ? "0" + h : h;
  let mm: any = time.getMinutes();
  mm = mm < 10 ? "0" + mm : mm;
  let s: any = time.getSeconds();
  s = s < 10 ? "0" + s : s;
  return `${y}-${m}`;
};

//获取当时的日期
export const getDate = function() {
  const time = new Date();
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return `${y}年${m}月${d}日`;
};

export const getDay = function() {
  const time = new Date();
  const d = time.getDay();
  const arr = [
    "星期天",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ];
  return arr[d];
};

export const getTime = function() {
  const time = new Date();
  let h: any = time.getHours();
  h = h < 10 ? "0" + h : h;
  let m: any = time.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s: any = time.getSeconds();
  s = s < 10 ? "0" + s : s;
  return `${h}:${m}:${s}`;
};

export const testEmail = function(data: any) {
  let result = false;
  const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
  if (data && reg.test(data)) {
    result = true;
  }
  return result;
};
export const deepClone = (target: any): any => {
  // 定义一个变量
  let result: any;
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === "object") {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = []; // 将result赋值为一个数组，并且执行遍历
      for (let i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]));
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null;
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target;
  }
  // 返回最终结果
  return result;
};
export const ajaxGet = function(url: any, fn: any) {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, false);
  xhr.onreadystatechange = function() {
    if (xhr.readyState == 4) {
      if (xhr.status == 200 || xhr.status == 304) {
        let result = xhr.responseText;
        try {
          result = JSON.parse(result);
        } catch {}
        fn(result);
      }
    }
  };
  xhr.send();
};
export const validForm = function(ref: any) {
  return new Promise((resolve: any, reject: any) => {
    ref.validate((valid: any) => {
      if (valid) {
        resolve(true);
        return true;
      }
      resolve(false);
      return false;
    });
  });
};
// 仅此项目
// 过滤areaData为element可用数据格式
export const filterAreaData = function(arr: any) {
  const tempArr = arr;
  const filterArr = tempArr.map((item: any) => {
    const {
      cityId,
      provinceId,
      areaId,
      cityName,
      provinceName,
      areaName,
      cities,
      areas,
      departments,
      parent,
    } = item;
    const depart = departments.map(
      ({ id: value, departmentName: label }: any) => {
        return { value: String(value), label };
      }
    );
    const value = areaId || cityId || provinceId;
    const label = areaName || cityName || provinceName;
    let { parentItem } = item;
    let level: number = 0;
    if (!parent) {
      level = 1;
    } else {
      if (areaId) {
        level = 3;
      } else if (cityId) {
        level = 2;
      } else if (provinceId) {
        level = 1;
      }
      if (areaId) {
        level = 3;
      }
      // let parentItem: any = {};
    }
    let originChildren: any = cities || areas;
    if (originChildren) {
      let children = originChildren.map((child: any) => {
        parentItem = {
          parent: {
            depart,
            value,
            label,
          },
          ...parentItem,
        };
        const itm = { ...child, ...parentItem };
        return itm;
      });
      children = filterAreaData(children);
      return {
        level,
        value,
        label,
        depart,
        children,
        parent: parent ? parent : null,
      };
    }
    return {
      parent: parent ? parent : null,
      level,
      parentItem,
      value,
      label,
      depart,
    };
  });
  return filterArr;
};
export const getAreaDepartmentByLastCode = function(arr: any, areaCode: any) {
  let findedData: any = {};
  if (!arr || arr.length == 0) {
    return null;
  }
  arr.find((province: any) => {
    if (province.id == areaCode) {
      findedData = province;
      return true;
    } else {
      if (province.children) {
        findedData = getAreaDepartmentByLastCode(province.children, areaCode);
      }
      if (findedData && findedData.hasOwnProperty("id")) {
        return true;
      } else {
        return false;
      }
    }
  });
  return findedData;
};

export const getAreaDepartmentByLastId = function(arr: any, areaId: any) {
  let findedData: any = {};
  if (!arr || arr.length == 0) {
    return null;
  }
  arr.find((province: any) => {
    if (province.id == areaId) {
      findedData = province;
      return true;
    } else {
      if (province.children) {

        findedData = getAreaDepartmentByLastId(province.children, areaId);
        // findedData.parentName = province.name;
      }
      if (findedData && findedData.hasOwnProperty("id")) {
        return true;
      } else {
        return false;
      }
    }
  });
  return findedData;
};
export const getParentArea = function(arr: any, areaCode: any) {
  const findedData = getAreaDepartmentByLastCode(arr, areaCode);
  if (!findedData) {
    return null;
  }
  const { parent } = findedData;
  return parent || null;
};
export const getAreaCN = function(arr: any, areaCode: any) {
  if (areaCode === "100000") {
    return {
      value: "100000",
      label: "中央",
    };
  }
  const code =
    areaCode instanceof Array ? areaCode[areaCode.length - 1] : areaCode;
  const findedData = getAreaDepartmentByLastCode(arr, code);
  return findedData;
};
// export const getAreaNameByCode = function(arr: any, areaCode: any) {
// }
